'use client';

import { useEffect, useRef } from 'react';

import styles from './HeaderLogo.module.scss';

const COLLAPSE_AT = 32;
const EXPAND_AT = 8;
const LOGO_WIDTH = 85;

export const HeaderLogo = () => {
  const logoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const logo = logoRef.current;
    if (!logo) return;

    let collapsed = logo.dataset.collapsed === 'true';

    const setCollapsed = (nextCollapsed: boolean) => {
      if (collapsed === nextCollapsed) return;

      collapsed = nextCollapsed;
      logo.dataset.collapsed = String(nextCollapsed);
    };

    const update = () => {
      const y = window.scrollY;

      if (collapsed && y < EXPAND_AT) {
        setCollapsed(false);
      } else if (!collapsed && y > COLLAPSE_AT) {
        setCollapsed(true);
      }
    };

    update();
    window.addEventListener('scroll', update, { passive: true });

    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <div ref={logoRef} className={styles.logo} data-collapsed="false">
      <svg
        width={LOGO_WIDTH}
        height={28}
        viewBox="0 0 86 28"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        className={styles.svg}
      >
        <path
          className={styles.fadeGlyph}
          d="M48.1382 26.0254H42.1199L42.558 1.5238L49.1122 0L48.1382 26.0254Z"
        />
        <path
          className={styles.wGlyph}
          d="M25.7434 5.44095L20.9595 26.0226H14.207L12.6054 17.1657L10.551 26.0226H4.1981L0.20166 11.3858L6.77063 9.85613L8.05837 18.6217L9.89082 9.13108L15.2579 7.88139L17.2295 18.7602L18.4728 7.1357L25.7404 5.4439L25.7434 5.44095Z"
        />
        <path
          className={styles.fadeGlyph}
          d="M56.0454 26.0253H49.9648L50.9388 0.0559082L57.8512 1.8656L56.0483 26.0224L56.0454 26.0253Z"
        />
        <g className={styles.mark}>
          <path
            className={styles.markBar}
            d="M85.1986 9.0188L82.0015 20.9233H76.9067L78.4461 7.25037L85.2016 9.0188H85.1986Z"
          />
          <path
            className={styles.markDot}
            d="M81.5811 25.1204C81.5811 26.712 80.2845 28 78.6889 28C77.0933 28 75.7966 26.709 75.7966 25.1204C75.7966 23.5317 77.0933 22.2408 78.6889 22.2408C80.2845 22.2408 81.5811 23.5317 81.5811 25.1204Z"
          />
        </g>
        <path
          className={styles.fadeGlyph}
          d="M33.061 8.16394C26.1191 8.83889 24.9468 15.0048 24.9468 17.7312C24.9468 20.7817 27.1552 26.0575 32.768 26.0575C37.5223 26.0575 38.9314 24.8019 38.9314 24.8019L39.0379 19.6971C39.0379 19.6971 37.8124 21.2916 34.7514 21.7042C31.8443 22.0962 31.1043 19.7383 31.1043 19.7383L40.4411 18.6537C40.4411 18.6537 42.2529 7.27383 33.061 8.16689V8.16394ZM35.3435 15.7829L31.0243 16.3813C31.0243 16.3813 31.646 13.596 33.5021 13.596C35.3583 13.596 35.3435 15.7829 35.3435 15.7829Z"
        />
        <path
          className={styles.fadeGlyph}
          d="M67.1111 8.11401C62.2798 8.11401 58.3604 12.1225 58.3604 17.0711C58.3604 22.0198 62.2769 26.0282 67.1111 26.0282C71.9453 26.0282 75.8618 22.0198 75.8618 17.0711C75.8618 12.1225 71.9453 8.11401 67.1111 8.11401ZM67.1111 20.3015C65.4474 20.3015 64.0975 18.8543 64.0975 17.0682C64.0975 15.2821 65.4474 13.8349 67.1111 13.8349C68.7748 13.8349 70.1247 15.2821 70.1247 17.0682C70.1247 18.8543 68.7748 20.3015 67.1111 20.3015Z"
        />
      </svg>
    </div>
  );
};
